<template>
    <div class="row mb-2">
        <div class="col-4">
            <v-select class="form-control"
                v-model="typeModel"

                :options="typeOptions"
                :disabled="!canWrite || typeOptions.length === 0"
                :clearable="false"
                

                searchable
                filterable
            >
                <div slot="no-options" />
            </v-select>
        </div>
        <div class="col-5">
            <v-select  v-if="isDropdown"
                class="form-control"
                v-model="dropdownValueModel"

                :options="fields"
                :disabled="!canWrite || fields.length === 0"
                :clearable="false"

                searchable
                filterable
            >
                <div slot="no-options" />
            </v-select>

            <input v-else
                   type="text"
                   class="form-control"
                   v-model="valueModel"
                   :disabled="!canWrite || fields.length === 0" />
        </div>
        <div class="col-3 d-flex">
            <button class="btn btn-outline-danger ml-auto" @click="$emit('delete', newValue.id)">
                <i class="fa fa-trash"></i> {{resource('Button_Remove')}}
            </button>
        </div>
    </div>
</template>

<script>

import resources from '../../../../../../Util/Mixins/resources';
import VSelect from 'vue-select';
import api from '../../../../api';
import { bootstrapDangerGrowl } from '../../../../../../Util/growler';

export default {
    name: 'touchpoint-custom-field',
    mixins: [resources],
    components: {
        VSelect
    },
    created() {
        this.newValue = this.value || {};

        api.getCustomFields(this.parentType).then(
            (result) => {
                this.types = result.types;
                
                this.fields = result.fields.map((field) => {
                    return {
                        id: field.id,
                        label: field.value
                    };
                });
            }
        );
    },
    computed: {
        dropdownValueModel: {
            get(){
                const field = this.fields.find((field) => field.id === this.newValue.value);
                const label = field ? field.label : '';

                return {
                    label: label,
                    type: this.newValue.type,
                    value: this.newValue.value
                };
            },
            set(value){
                this.newValue.value = value.id;  
            }
        },
        valueModel: {
            get() {
                return this.newValue.value;
            },
            set(value) {
                this.newValue.value = value;
            }
        },
        typeModel: {
            get() {
                return {
                    label: this.newValue.type,
                    value: this.newValue.type
                }
            },
            set(type) {
                this.newValue.type = type;
            }
        },
        typeOptions(){
            return this.types.map(({name}) => name);
        },
        isDropdown(){
            const selectedType = this.types.find(t => t.name === this.newValue.type);
            if(selectedType){
                return selectedType.isDropdown;
            }
            
            return false;
        }
    },
    watch: {
        parentType(value) {
            this.$emit('delete', this.value.id);
        },
        newValue: {
            handler(value) {
                this.$emit('input', value);
            },
            deep: true
        }
    },
    data() {
        return {
            newValue: {},
            type: null,
            types: [],
            fields: []
        }
    },
    props: {
        canWrite: {
            type: Boolean,
            required: true
        },
        parentType: {
            type: String,
            required: true
        },
        value: {
            type: Object,
            required: true
        }
    }
};
</script>